const env = process.env.NODE_ENV

const Setting = {
    /**
     * 基础配置
     * */
    // 路由模式，可选值为 history 或 hash
    routerMode: 'hash',
    // 1是H5页面 2是安卓 3是sIOS
    isMoudle: 1,
    // 预览请求地址
    previewUrl: env === 'development' ? 'http://127.0.0.1:8012/onlinePreview?url=' : 'http://47.116.3.15:8012//onlinePreview?url=',
    // 接口请求地址
    // apiBaseURL: env === 'development' ? 'http://localhost:8000/' : 'http://lg.sit.lantiandun.com/app/',
    apiBaseURL: env === 'development' ? 'https://lghbgjapp.lantiandun.com/mobile/' : 'https://lghbgjapp.lantiandun.com/mobile/',
    cookieDomain: env === 'development' ? 'localhost' : '.lantiandun.com',
    // 接口请求返回错误时，弹窗的持续时间，单位：毫秒
    modalDuration: 1000,
    // 接口请求返回错误时，弹窗的类型，可选值为 Toast 或 Notify
    errorModalType: 'Toast',
    // Cookies 默认保存时间，单位：天
    cookiesExpires: 1
}

export default Setting
